export const lookup = "site-config-lookups/inferno";
